module.exports = __webpack_public_path__ + "img/19.05c35f72.jpg";